import classNames from "components/ui/classNames";
import { SimpleTextTooltip } from "components/ui/Tooltip";
import { BookmarkIcon } from "lucide-react";

export default function InBookmarksTag() {
  return (
    <SimpleTextTooltip content="Nos Favoritos">
      <div
        className={classNames(
          "inline-flex items-center justify-center space-x-2 rounded-md bg-amber-50 px-2 py-1 text-orange-600",
          "dark:bg-orange-800/10 dark:text-slate-400",
        )}
      >
        <BookmarkIcon strokeWidth={0} className="inline-flex h-5 w-5 fill-orange-500 text-orange-600" />
      </div>
    </SimpleTextTooltip>
  );
}
